import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import { useCurrencySymbol } from '../../../../../utils/currencyUtils';
import CommaConvert from '../../../../../utils/CommaConvert';
import {
  formatAmountComma,
  parseAmountNumber,
} from '../../../../../utils/decimalAmountUtils';
import {
    applyLiveTrainingTotalToOtherExpenseRows,
    consolidateTrainingExpenseRowsForDisplay,
    filterInstallationOngoingOtherExpenseDisplayRows,
    getLiveTrainingRollupForOpsAssigneeProject,
    isTrainingExpenseDisplayRow,
} from '../../../../../utils/trainingOtherExpenseSync';

const ShowApprovedTaskDetails = ({
    proj,
    items,
    index,
    tasks,
    entries,
    employees,
    projectTrackingWorkEntries,
    hardwareProjectTracking,
    descriptionProjectTracking
}) => {
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();
    const { mytrainings } = useSelector((state) => state.myTrainings);
    const { projects } = useSelector((state) => state.projects);

    const [activeSection, setActiveSection] = useState(null); // 'taskKey' or 'expenseKey'
    const [selectedDescriptions, setSelectedDescriptions] = useState([]);
    const [selectedWorkEntries, setSelectedWorkEntries] = useState([]);
    const [projectSummary, setProjectSummary] = useState(null);
    console.log("items1 items", items)
    console.log("items1 projectSummary", projectSummary)
    console.log("items1 selectedDescriptions", selectedDescriptions)

    const processHardwarePMOperations = ({
        hardwareEntries = [],
        employees = [],
        currentEmpId,
    }) => {

        if (!currentEmpId) return [];

        // 1️⃣ Build employee role map
        const empRoleMap = employees.reduce((acc, emp) => {
            acc[emp._id] = emp?.customRoles?.[0];
            return acc;
        }, {});

        const currentRole = empRoleMap[currentEmpId];

        // 2️⃣ If NOT project manager → return own hardware only
        if (currentRole !== "project manager") {
            return hardwareEntries.filter(
                h => h.taskownerid === currentEmpId
            );
        }

        // 3️⃣ Group all hardware by assembly part
        const groupedByAssembly = hardwareEntries.reduce((acc, part) => {
            const key = part.assemblepartdescription;
            if (!acc[key]) acc[key] = [];
            acc[key].push(part);
            return acc;
        }, {});

        const pmResult = [];

        // 4️⃣ Apply PM vs OP comparison logic
        Object.values(groupedByAssembly).forEach(parts => {

            const pmParts = parts.filter(
                p =>
                    p.taskownerid === currentEmpId &&
                    empRoleMap[p.taskownerid] === "project manager"
            );

            const opParts = parts.filter(
                p =>
                    empRoleMap[p.taskownerid] === "operations"
            );

            // Case A: PM & OP both exist → take highest quantity
            if (pmParts.length && opParts.length) {
                const highestPM = pmParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );

                const highestOP = opParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );

                pmResult.push(
                    Number(highestOP.quantity) > Number(highestPM.quantity)
                        ? { ...highestOP }
                        : { ...highestPM }
                );
            }

            // Case B: Only OP exists → PM takes OP highest
            else if (!pmParts.length && opParts.length) {
                const highestOP = opParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );
                pmResult.push({ ...highestOP });
            }

            // Case C: Only PM exists → PM keeps own
            else if (pmParts.length) {
                const highestPM = pmParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );
                pmResult.push({ ...highestPM });
            }
        });

        // 5️⃣ Return PM-specific computed list
        return pmResult;
    };
    const processFalseHardwarePMOperations = ({
        hardwareEntries = [],
        employees = [],
        currentEmpId,
    }) => {

        if (!currentEmpId) return [];

        // 1️⃣ Build employee role map
        const empRoleMap = employees.reduce((acc, emp) => {
            acc[emp._id] = emp?.customRoles?.[0];
            return acc;
        }, {});

        const currentRole = empRoleMap[currentEmpId];

        // 2️⃣ If NOT project manager → return own hardware only
        if (currentRole !== "project manager") {
            return hardwareEntries.filter(
                h => h.taskownerid === currentEmpId
            );
        }

        // 3️⃣ Group all hardware by assembly part
        const groupedByAssembly = hardwareEntries.reduce((acc, part) => {
            const key = part.assemblepartdescription;
            if (!acc[key]) acc[key] = [];
            acc[key].push(part);
            return acc;
        }, {});

        const pmResult = [];

        // 4️⃣ Apply PM vs OP comparison logic
        Object.values(groupedByAssembly).forEach(parts => {

            const pmParts = parts.filter(
                p =>
                    p.taskownerid === currentEmpId &&
                    empRoleMap[p.taskownerid] === "project manager"
            );

            const opParts = parts.filter(
                p =>
                    empRoleMap[p.taskownerid] === "operations"
            );

            // Case A: PM & OP both exist → take highest quantity
            if (pmParts.length && opParts.length) {
                const highestPM = pmParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );

                const highestOP = opParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );

                pmResult.push(
                    Number(highestOP.quantity) > Number(highestPM.quantity)
                        ? { ...highestOP }
                        : { ...highestPM }
                );
            }

            // Case B: Only OP exists → PM takes OP highest
            else if (!pmParts.length && opParts.length) {
                const highestOP = opParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );
                pmResult.push({ ...highestOP });
            }

            // Case C: Only PM exists → PM keeps own
            else if (pmParts.length) {
                const highestPM = pmParts.reduce((a, b) =>
                    Number(b.quantity) > Number(a.quantity) ? b : a
                );
                pmResult.push({ ...highestPM });
            }
        });

        // 5️⃣ Return PM-specific computed list
        return pmResult;
    };

    useEffect(() => {
        if (!proj || !employees) return;

        const mergeDescriptionsWithSingleTrainingRow = (descList, assigneeEmp) => {
            let descRows = [...(descList || [])];
            const liveRollup = getLiveTrainingRollupForOpsAssigneeProject({
                projectRow: proj,
                assigneeEmp,
                trainingsEnvelope: mytrainings,
                projects,
                currencySymbol: currency,
            });
            const liveAmt = liveRollup ? Number(liveRollup.amount) || 0 : 0;
            const liveNotes = String(liveRollup?.notes || "").trim();
            const hasTrainingInBase = descRows.some((d) => isTrainingExpenseDisplayRow(d));
            if (liveAmt > 0 && !hasTrainingInBase && assigneeEmp?._id) {
                descRows.push({
                    _id: `training_cost_${String(assigneeEmp._id).trim()}-${String(proj?._id || "").trim()}`,
                    projectid: proj._id,
                    taskownerid: assigneeEmp._id,
                    description: liveRollup.description || `Training Cost (${currency})`,
                    value: liveAmt,
                    notes: liveNotes,
                    isTaskComplete: true,
                    expenses: liveAmt,
                });
            }
            let merged = consolidateTrainingExpenseRowsForDisplay(descRows);
            if (liveAmt > 0 && merged.some((d) => isTrainingExpenseDisplayRow(d))) {
                merged = applyLiveTrainingTotalToOtherExpenseRows(merged, liveAmt, liveNotes, currency);
            }
            return filterInstallationOngoingOtherExpenseDisplayRows(merged, proj);
        };

        const assignedPersons = proj.Assignedperson.map((person) => {
            const matchedEmp = employees.find(
                (emp) => emp.EmpEmail === person.email
            );

            const matchedAllWorkEntries = entries.filter(
                (entry) =>
                    entry.projectid === proj?._id
            );

            const matchedWorkEntries = entries.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            const matchedDescriptionsAll = tasks.filter(
                (entry) =>
                    entry.projectid === proj?._id
            );
            // Normalize taskownerid (may be raw id or populated object)
            const getDescOwnerId = (d) =>
                d?.taskownerid && typeof d.taskownerid === "object" && d.taskownerid._id != null
                    ? d.taskownerid._id
                    : d?.taskownerid;

            // Other expenses: always show only this person's (manager or employee), not aggregated
            const matchedDescriptions = matchedDescriptionsAll?.filter(
                (desc) => String(getDescOwnerId(desc) || "") === String(matchedEmp?._id || "")
            ) || [];

            const matchedHardwaresFalseAll = items.filter(
                (entry) =>
                    entry.projectid === proj?._id
            );
            // const matchedHardwares = items.filter(
            //     (entry) =>
            //         entry.projectid === proj?._id &&
            //         entry.taskownerid === matchedEmp?._id
            // );
            let matchedHardwares = [];

            if (proj?.TypeService === "Hardware") {
                matchedHardwares = processFalseHardwarePMOperations({
                    hardwareEntries: matchedHardwaresFalseAll,
                    employees,
                    currentEmpId: matchedEmp?._id,
                });
            }

            const matchedWorkEntriestrue = projectTrackingWorkEntries.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            const matchedDescriptionstrueAll = descriptionProjectTracking.filter(
                (entry) =>
                    entry.projectid === proj?._id
            );

            // Other expenses (project tracking): always show only this person's, not aggregated
            const matchedDescriptionstrue = matchedDescriptionstrueAll?.filter(
                (desc) => String(getDescOwnerId(desc) || "") === String(matchedEmp?._id || "")
            ) || [];

            const matchedHardwarestrueAll = hardwareProjectTracking.filter(
                (entry) =>
                    entry.projectid === proj?._id
            );

            let matchedHardwarestrue = [];

            if (proj?.TypeService === "Hardware") {
                matchedHardwarestrue = processHardwarePMOperations({
                    hardwareEntries: matchedHardwarestrueAll,
                    employees,
                    currentEmpId: matchedEmp?._id,
                });
            }

            return {
                name: person.name,
                email: person.email,
                role: matchedEmp?.customRoles?.[0] || null,
                empid: matchedEmp?._id || null,
                workEntries: matchedWorkEntries,
                descriptionList: mergeDescriptionsWithSingleTrainingRow(matchedDescriptions, matchedEmp),
                hardwareList: matchedHardwares,
                matchedAllWorkEntries: matchedAllWorkEntries,
                workEntriesrtrue: matchedWorkEntriestrue,
                descriptionListtrue: mergeDescriptionsWithSingleTrainingRow(matchedDescriptionstrue, matchedEmp),
                hardwareListtrue: matchedHardwarestrue,
            };
        });

        const sortedAssignedPersons = [
            ...assignedPersons.filter(p => p.role === "project manager"),
            ...assignedPersons.filter(p => p.role !== "project manager")
        ];

        // Step 3: Build summary
        const summary = {
            _id: proj._id,
            TypeService: proj.TypeService,
            ProjectName: proj.ProjectName,
            Assignedperson: sortedAssignedPersons,
        };

        setProjectSummary(summary);
    }, [proj, employees, tasks, entries, descriptionProjectTracking, hardwareProjectTracking, projectTrackingWorkEntries, items, mytrainings, projects, currency]);


    // const matchedDescriptionstrue = descriptionProjectTracking.filter(
    //     (entry) =>
    //         entry.projectid === proj?._id &&
    //         entry.taskownerid === matchedEmp?._id
    // );

    const downloadPDFHardware = (hardwareList) => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [
                [
                    "Sr. No",
                    "Part Name",
                    "Part Number",
                    "Quantity",
                    `Unit Price (${currency})`,
                    `Total Price (${currency})`,
                ],
            ],
            body: hardwareList.map((LeadReport, index) => [
                index + 1,
                LeadReport.assemblepartdescription,
                LeadReport.partno,
                LeadReport.quantity,
                USAComma(LeadReport.unitprice),
                USAComma(LeadReport.totalprice),
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("Hardware PartList.pdf");
    };

    const downloadPDFHardwareDescriptions = (descriptionList) => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [["Sr. No", "Description", `Amount (${currency}) `, "Notes"]],
            body: descriptionList.map((LeadReport, index) => [
                index + 1,
                LeadReport.description,
                formatAmountComma(LeadReport.value),
                LeadReport.notes,
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("Hardware OtherExpensesList.pdf");
    };


    const pickPersonDescriptionList = (person) => {
        const raw =
            person?.descriptionList?.length > 0
                ? person.descriptionList
                : person?.descriptionListtrue || [];
        return filterInstallationOngoingOtherExpenseDisplayRows(raw, proj);
    };

    const handlePersonClick = (person, taskKey) => {
        if (activeSection === taskKey) {
            // If clicking the same person when already expanded, close it
            setActiveSection(null);
            setSelectedDescriptions([]);
            setSelectedWorkEntries([]);
        } else {
            setActiveSection(taskKey);
            setSelectedDescriptions(pickPersonDescriptionList(person));
            setSelectedWorkEntries(
                person.workEntries && person.workEntries.length > 0
                    ? person.workEntries
                    : person.workEntriesrtrue || []
            );
        }
    };

    const handleTabClick = (person, key, type) => {
        if (type === 'task') {
            setActiveSection(key);
        } else if (type === 'expense') {
            setActiveSection(`${key}-expense`);
        }
        setSelectedDescriptions(pickPersonDescriptionList(person));

        setSelectedWorkEntries(
            person.workEntries && person.workEntries.length > 0
                ? person.workEntries
                : person.workEntriesrtrue || []
        );
    };

    return (
        <div className="w-full">
            {projectSummary &&
                proj?._id?.toString() === projectSummary?._id?.toString() ? (
                projectSummary.Assignedperson.map((person, idx) => {
                    const taskKey = `${proj.TypeService}-${index}_${person.empid}_${projectSummary.TypeService}_${proj._id}-tasktable`;
                    const expenseKey = `${taskKey}-expense`;
                    const isActive = activeSection === taskKey || activeSection === expenseKey;
                    return (
                        <div key={idx} className="flex flex-col w-full h-full">
                            {person?.hardwareList?.length || person.workEntries?.length || person?.descriptionList?.length ? (
                                <div className="flex">
                                    <div className="w-[33%] flex justify-center align-middle items-center text-center border-b p-2">
                                        <button
                                            onClick={() => handlePersonClick(person, taskKey)}
                                            className={`${isActive
                                                ? "bg-blue-500 text-white rounded-md px-2 py-1"
                                                : "bg-transparent"
                                                } transition-colors duration-200 text-center flex justify-center align-middle items-center`}
                                        >
                                            {projectSummary.TypeService}{" "}
                                            {person.role === "project manager" ? "Manager" : "Employee"}
                                        </button>
                                    </div>

                                    <div
                                        className="w-[67%] flex  cursor-pointer"
                                    >
                                        {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                            <div
                                                onClick={() => handlePersonClick(person, taskKey)}
                                                className="w-[50%] border-b pr-3 flex justify-center items-center ">
                                                {person?.hardwareList?.length || ""}
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() => handlePersonClick(person, taskKey)}
                                                className="w-[50%] border-b pr-3 flex justify-center items-center ">
                                                {person.workEntries?.length
                                                    ? person.workEntries.reduce(
                                                        (sum, item) =>
                                                            sum + Number(item.hoursassigned || 0),
                                                        0
                                                    )
                                                    : ""}
                                            </div>
                                        )}

                                        {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                            // {proj.TypeService === "Hardware" ? (
                                            <div
                                                onClick={() => handlePersonClick(person, expenseKey)}
                                                className="w-[50%] border-b pr-3 flex justify-center items-center">
                                                {person?.descriptionList?.length || ""}
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() => handlePersonClick(person, expenseKey)}
                                                className="w-[50%] border-b pr-3 flex justify-center items-center ">
                                                {person.descriptionList?.length
                                                    ? formatAmountComma(
                                                        person.descriptionList.reduce(
                                                            (sum, item) => sum + parseAmountNumber(item.value),
                                                            0
                                                        )
                                                    )
                                                    : ""
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className='w-full h-12   flex justify-center align-middle items-center'>
                                    <div onClick={() => handlePersonClick(person, taskKey)}
                                        className="w-[33%]  border-b h-full p-2 cursor-pointer  flex justify-center items-center text-center">
                                        {projectSummary.TypeService}
                                        <br />
                                        {person.role === "project manager" ? "Manager" : "Employee"}
                                    </div>
                                    <div
                                        onClick={() => handlePersonClick(person, taskKey)}
                                        className="w-[33%] h-full  cursor-pointer border-b  flex justify-center items-center">
                                        {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                            <div className="  h-full  flex justify-center items-center">
                                                {person?.hardwareListtrue?.length || ""}
                                            </div>
                                        ) : (
                                            <div className="  h-full   flex justify-center items-center ">
                                                {person.workEntriesrtrue?.length
                                                    ? person.workEntriesrtrue.reduce(
                                                        (sum, item) =>
                                                            sum + Number(item.hoursassigned || 0),
                                                        0
                                                    )
                                                    : ""}
                                            </div>
                                        )}
                                    </div>
                                    <div onClick={() => handlePersonClick(person, expenseKey)}
                                        className="w-[34%]  h-full border-b cursor-pointer p-2 flex justify-center items-center">
                                        {person.descriptionListtrue?.length || " "}
                                        {/* {person.descriptionListtrue?.length
                                            ? USAComma(
                                                person.descriptionListtrue.reduce(
                                                    (sum, item) => sum + Number(item.value || 0),
                                                    0
                                                )
                                            )
                                            : ""
                                        } */}
                                    </div>
                                </div>
                            )}

                            {isActive && (
                                <div className="p-1 pl-[2%] flex justify-center gap-1 text-[11px]">
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent event from bubbling to parent
                                            handleTabClick(person, taskKey, 'task');
                                        }}
                                        className={`cursor-pointer py-1 px-1 inline-block border rounded-md text-start transition-colors duration-200 ${activeSection === taskKey
                                            ? "bg-blue-500 text-white border-blue-500"
                                            : "bg-white border-gray-300 hover:bg-gray-50"
                                            }`}
                                    >
                                        {proj?.TypeService?.toLowerCase().includes("hardware")
                                            ? "Part List"
                                            : "Effort Expenses"}
                                    </div>

                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent event from bubbling to parent
                                            handleTabClick(person, taskKey, 'expense');
                                        }}
                                        className={`cursor-pointer py-1 px-1 inline-block border rounded-md text-start transition-colors duration-200 ${activeSection === expenseKey
                                            ? "bg-blue-500 text-white border-blue-500"
                                            : "bg-white border-gray-300 hover:bg-gray-50"
                                            }`}
                                    >
                                        Other Expenses
                                    </div>
                                </div>
                            )}

                            {activeSection === taskKey && (
                                <div className='w-full'>
                                    {/* ... rest of your task table rendering code remains the same ... */}
                                    {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                        // {proj.TypeService === "Hardware" ? (
                                        <div className="flex justify-center w-full mb-2">
                                            <div className=" border border-gray-300  overflow-hidden ">
                                                <div className="grid grid-cols-3 bg-[#e8e8e8] text-[11px] font-semibold break-all whitespace-normal">
                                                    <div className="p-2 border-b text-center">
                                                        Total Parts
                                                    </div>
                                                    <div className="p-2 border-b text-center">
                                                        Total Price ({currency})
                                                    </div>
                                                    <div className="p-2 border-b text-center">Action</div>
                                                </div>

                                                {(person?.hardwareList?.length) ? (
                                                    <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                        <div className="p-1 border-b border-blue-200 text-center">
                                                            {person?.hardwareList.length}
                                                        </div>
                                                        <div className="p-1 border-b border-blue-200 text-center">
                                                            {USAComma(
                                                                person?.hardwareList?.reduce((sum, item) => {
                                                                    return sum + (item.totalprice || 0);
                                                                }, 0)
                                                            )}
                                                        </div>
                                                        <div
                                                            title="Download Hardware Part List"
                                                            onClick={() =>
                                                                downloadPDFHardware(person?.hardwareList)
                                                            }
                                                            className="p-1 text-center border-b cursor-pointer hover:bg-blue-50"
                                                        >
                                                            Download
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                        <div className="p-1 border-b border-blue-200 text-center">
                                                            {person?.hardwareListtrue.length}
                                                        </div>
                                                        <div className="p-1 border-b border-blue-200 text-center">
                                                            {USAComma(
                                                                person?.hardwareListtrue?.reduce((sum, item) => {
                                                                    return sum + (item.totalprice || 0);
                                                                }, 0)
                                                            )}
                                                        </div>
                                                        <div
                                                            title="Download Hardware Part List"
                                                            onClick={() =>
                                                                downloadPDFHardware(person?.hardwareListtrue)
                                                            }
                                                            className="p-1 text-center border-b cursor-pointer hover:bg-blue-50"
                                                        >
                                                            Download
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex justify-center mx-auto pb-2">
                                            <div className="w-full max-h-[14rem] overflow-y-auto border">
                                                {selectedWorkEntries.length > 0 ? (
                                                    <>
                                                        {selectedWorkEntries.length > 0 && (
                                                            <div className="sticky top-0 w-full">
                                                                <div className=" head flex text-center bg-[#e8e8e8]  text-[11px]">
                                                                    <div className="w-[40%]  p-1">Task</div>
                                                                    <div className="w-[30%]  p-1">
                                                                        Hours
                                                                    </div>
                                                                    <div className="w-[30%]  p-1">
                                                                        Notes
                                                                    </div>
                                                                </div>

                                                                <div className="head flex text-center text-[11px] font-semibold  ">
                                                                    <div className="w-[40%] border-b break-all whitespace-normal p-1">
                                                                        {"Total"}
                                                                    </div>
                                                                    <div className="w-[30%] border-b break-all whitespace-normal p-1">
                                                                        {selectedWorkEntries?.reduce(
                                                                            (sum, item) => sum + item.hoursassigned,
                                                                            0
                                                                        ) || 0}
                                                                        {""}
                                                                    </div>
                                                                    <div className="w-[30%] border-b break-all whitespace-normal p-1">
                                                                        {" "}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {selectedWorkEntries.map((entry, index) => (
                                                            <div
                                                                key={index}
                                                                className="head flex text-center text-[11px]"
                                                            >
                                                                <div className="w-[40%] border-b break-all whitespace-normal p-1">
                                                                    {entry.task}
                                                                </div>
                                                                <div className="w-[30%] border-b break-all whitespace-normal p-1">
                                                                    {entry.hoursassigned}
                                                                </div>
                                                                <div className="w-[30%] border-b break-all whitespace-normal p-1">
                                                                    {entry.notes}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div className="head bg-slate-400 flex text-red-500 text-[11px]">
                                                        <p className="w-full text-center">
                                                            No Data Available
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeSection === expenseKey && (
                                <div className='w-full '>
                                    {/* ... rest of your expense table rendering code remains the same ... */}
                                    {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                        // {proj.TypeService === "Hardware" ? (
                                        <>
                                            {person.descriptionListtrue?.length > 0 ? (
                                                <div className="flex justify-center w-full mb-2">
                                                    <div className="  border-gray-300  overflow-hidden border">
                                                        <div className="grid grid-cols-3 bg-[#e8e8e8] text-[11px] font-semibold break-all whitespace-normal">
                                                            <div className="p-1 border-r text-center">
                                                                Total Descriptions
                                                            </div>
                                                            <div className="p-1 border-b text-center">
                                                                Total Amount ({currency})
                                                            </div>
                                                            <div className="p-1 text-center">Action</div>
                                                        </div>

                                                        <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                            <div className="p-1 border-b  text-center">
                                                                {person.descriptionListtrue?.length}
                                                            </div>
                                                            <div className="p-1 border-b  text-center">
                                                                {formatAmountComma(
                                                                    (person?.descriptionListtrue)?.reduce((sum, item) => {
                                                                        return sum + parseAmountNumber(item.value);
                                                                    }, 0)
                                                                )}
                                                            </div>
                                                            <div
                                                                title="Download Description List"
                                                                onClick={() =>
                                                                    downloadPDFHardwareDescriptions(
                                                                        person?.descriptionListtrue
                                                                    )
                                                                }
                                                                className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                            >
                                                                Download
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="flex justify-center w-full mb-2">
                                                    <div className="  border-gray-300  overflow-hidden border">
                                                        <div className="grid grid-cols-3 bg-[#e8e8e8] text-[11px] font-semibold break-all whitespace-normal">
                                                            <div className="p-1 border-r text-center">
                                                                Total Descriptions
                                                            </div>
                                                            <div className="p-1 border-b text-center">
                                                                Total Amount ({currency})
                                                            </div>
                                                            <div className="p-1 text-center">Action</div>
                                                        </div>

                                                        <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                            <div className="p-1 border-b  text-center">
                                                                {person.descriptionList?.length}
                                                            </div>
                                                            <div className="p-1 border-b  text-center">
                                                                {formatAmountComma(
                                                                    (person?.descriptionList)?.reduce((sum, item) => {
                                                                        return sum + parseAmountNumber(item.value);
                                                                    }, 0)
                                                                )}
                                                            </div>
                                                            <div
                                                                title="Download Description List"
                                                                onClick={() =>
                                                                    downloadPDFHardwareDescriptions(
                                                                        person?.descriptionList
                                                                    )
                                                                }
                                                                className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                            >
                                                                Download
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="flex justify-center mx-auto pb-2">
                                            <div className="w-full max-h-[14rem] overflow-y-auto border">
                                                {selectedDescriptions.length > 0 ? (
                                                    <>
                                                        {selectedDescriptions.length > 0 && (
                                                            <div className="sticky top-0">
                                                                <div className=" head flex text-center bg-[#e8e8e8]  text-[11px] break-all whitespace-normal">
                                                                    <div className="w-[40%]  p-1">
                                                                        Description
                                                                    </div>
                                                                    <div className="w-[30%]  p-1">
                                                                        Amount ({currency})
                                                                    </div>
                                                                    <div className="w-[30%]  p-1">
                                                                        Notes
                                                                    </div>
                                                                </div>

                                                                <div className="head flex text-center font-semibold   text-[11px] break-all whitespace-normal ">
                                                                    <div className="w-[40%] border-b p-1">
                                                                        Total
                                                                    </div>
                                                                    <div className="w-[30%] border-b p-1">
                                                                        {formatAmountComma(
                                                                            selectedDescriptions?.reduce(
                                                                                (sum, item) => sum + parseAmountNumber(item.value),
                                                                                0
                                                                            ) || 0
                                                                        )}
                                                                    </div>
                                                                    <div className="w-[30%] border-b p-1">
                                                                      
                                                                        {" "}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {selectedDescriptions.map((entry, index) => (
                                                            <div
                                                                key={index}
                                                                className="head flex text-center text-[11px] break-all whitespace-normal"
                                                            >
                                                                <div className="w-[40%] border-b p-1">
                                                                    {entry.description}
                                                                </div>
                                                                <div className="w-[30%] border-b p-1">
                                                                    {formatAmountComma(entry.value)}
                                                                </div>
                                                                <div className="w-[30%] border-b p-1">
                                                                    {entry.notes}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div
                                                        className="head flex text-red-500 text-[11px]"
                                                    >
                                                        <p className="w-full text-center">
                                                            No Data Available
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })
            ) : (
                <p className="text-gray-500 text-sm">No project summary available</p>
            )}
        </div>
    )
}

export default ShowApprovedTaskDetails